import {
  TRADE_AMOUNT_TYPE,
  TRADE_SIDE,
  TRADE_TYPE,
} from "pages/BasicTrade/components/constants";

import { FixedMidpointRoundingToDown } from "./numbers";

export const calculateMaximumTradeAmount = ({
  sideId,
  amountTypeId,
  tradeTypeId,
  tradeAmountMax,
  srcDecimalCount,
  destDecimalCount,
  price,
}) => {
  const sideIsBuy = sideId === TRADE_SIDE.Buy.id;

  const amountTypeIsAmount = amountTypeId === TRADE_AMOUNT_TYPE.amount.id;
  const amountTypeIsTotal = amountTypeId === TRADE_AMOUNT_TYPE.total.id;

  const tradeTypeIsMarket = tradeTypeId === TRADE_TYPE.market.id;

  if (sideIsBuy) {
    if (tradeTypeIsMarket) {
      if (amountTypeIsAmount) {
        const max = tradeAmountMax?.tradeAmountMax;
        return FixedMidpointRoundingToDown(+max, srcDecimalCount);
      } else if (amountTypeIsTotal) {
        const max = tradeAmountMax?.tradeAmountMax * tradeAmountMax?.price;

        return FixedMidpointRoundingToDown(+max, destDecimalCount);
      }
    } else {
      if (amountTypeIsAmount) {
        const max = price ? tradeAmountMax?.availableBalance / +price : 0;

        return FixedMidpointRoundingToDown(+max, srcDecimalCount);
      } else if (amountTypeIsTotal) {
        const max = tradeAmountMax?.availableBalance;

        return FixedMidpointRoundingToDown(+max, destDecimalCount);
      }
    }
  } else {
    if (tradeTypeIsMarket) {
      if (amountTypeIsAmount) {
        const max = tradeAmountMax?.tradeAmountMax;

        return FixedMidpointRoundingToDown(+max, srcDecimalCount);
      } else if (amountTypeIsTotal) {
        const max = tradeAmountMax?.tradeAmountMax * tradeAmountMax?.price;

        return FixedMidpointRoundingToDown(+max, destDecimalCount);
      }
    } else {
      if (amountTypeIsAmount) {
        const max = tradeAmountMax?.availableBalance;

        return FixedMidpointRoundingToDown(+max, srcDecimalCount);
      } else if (amountTypeIsTotal) {
        const max = tradeAmountMax?.availableBalance * +price;

        return FixedMidpointRoundingToDown(+max, destDecimalCount);
      }
    }
  }
};
